import CommonLabel from "src/components/common/CommonLabel"
import Link from "next/link"
import routes from "routes"
import { WorkItem } from "../../../models/WorkItem/WorkItem"
import TieupImg from "src/components/common/TieupImg"
import { UserName } from "./userName"
import styles from "./searchResultBody.module.scss"
import clsx from "clsx"
import { LoadMoreButton } from "src/components/common/LoadMoreButton"
import { BarLoader } from "react-spinners"
import colors from "src/config/color"
import { SizeType } from "../../common/TieupImg/SizeType"

type Props = {
  data: WorkItem[] | undefined
  canLoadMore: boolean
  loadMore: () => void
  isLoading: boolean
}

export const SearchResultBody: React.FC<Props> = ({
  data,
  canLoadMore,
  isLoading,
  loadMore,
}) => {
  return (
    <>
      {data === undefined ? (
        <div className={styles.loader}>
          <BarLoader color={colors.spectrum.tieupTheme} />
        </div>
      ) : data.length > 0 ? (
        <div className={styles.list}>
          {data.map((item) => {
            return (
              <article key={item.id} className={styles.list_item}>
                <div className={styles.list_image}>
                  <Link href={routes.seriesDetail(item.novel_id.toString())}>
                    <a className={styles.list_image_anchor}>
                      <TieupImg
                        src={
                          item.novel.cover_template_image || "/img/cover.png"
                        }
                        size={SizeType.s}
                      />
                    </a>
                  </Link>
                </div>
                <div className={styles.list_detail}>
                  <p className={styles.list_copy}>{item.novel.catch_copy}</p>
                  <h2 className={styles.list_title}>
                    <Link href={routes.seriesDetail(item.novel_id.toString())}>
                      <a className={styles.list_title_anchor}>
                        {item.novel.title}
                      </a>
                    </Link>
                  </h2>
                  <ul className={styles.list_genre}>
                    {!!item.novel.genres &&
                      item.novel.genres.map((g) => (
                        <li key={g.id}>
                          <CommonLabel style="tertiary" text={g.name} />
                        </li>
                      ))}
                  </ul>
                  <ul
                    className={clsx([styles.list_tag, "p-wordList-secondary"])}
                  >
                    {!!item.novel.hashtags &&
                      item.novel.hashtags.map((h) => (
                        <li key={h.id}>{h.name}</li>
                      ))}
                  </ul>
                  {/* ユーザー名 */}
                  <UserName item={item} />
                </div>
              </article>
            )
          })}
        </div>
      ) : (
        <p className={styles.nothing}>検索結果が見つかりませんでした</p>
      )}

      {canLoadMore && (
        <LoadMoreButton
          autoLoadOnScroll={true}
          loadMore={loadMore}
          isLoading={isLoading}
        />
      )}
    </>
  )
}
